import {
    Banner,
    BannerDescription,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Button,
    FluidImage,
    Icon,
    Link,
} from '@vp/swan';
import { useTrack } from '../../../../utils/analytics';

// Google Workspace Owner: Digital Partners - https://vistaprint.slack.com/archives/C07CD774A2K
// https://vistaprint.atlassian.net/wiki/spaces/LTTS/pages/4749800988/2025-04-16+Release+Notes+Launch+of+Google+Workspace+CTA+and+Banner+on+BNG+Landing+page

const GoogleWorkspaceBanner = () => {
    const gwsTrackingSpec: Record<string, string> = {
        promotion_id: 'gwsBanner:BNG PDP',
        creative: 'Gws Promo Banner',
        name: 'gwsBanner',
        position: 'BNG Promo Banner',
        stage: 'Promotions',
    };

    const track = useTrack();
    const handlePromotionClicked = () => {
        track('Promotion Clicked', gwsTrackingSpec);
    };

    return (
        <Banner variant="card" textBoxHorizontalAlign="right">
            <BannerTextContainer>
                <BannerText>
                    <BannerTitle>Get Your Professional Business Email Address</BannerTitle>
                    <BannerDescription>
                        <p>
                            Every interaction is an opportunity. With Wix, make a strong first
                            impression with a professional website and a business email address that
                            builds trust and sets you up for success.
                        </p>
                    </BannerDescription>
                    <BannerLinks>
                        <Button
                            skin="primary"
                            render={(props) => (
                                <Link
                                    to="/digital-marketing/google-workspace"
                                    className={props.className}
                                    onClick={handlePromotionClicked}
                                >
                                    {props.children}
                                </Link>
                            )}
                        >
                            Know More
                            <Icon iconType="arrowRight" />
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <BannerImageContainer>
                <BannerImage>
                    <FluidImage
                        srcSet="https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/vista-logos-pages/en-US/business-name-generator/google-workspace-image.webp"
                        alt="An office scene where the user is working on their website and have recieved a email notification from Google Workspace"
                        style={{
                            borderRadius: '16px',
                            objectFit: 'cover',
                            objectPosition: '85%',
                        }}
                    />
                </BannerImage>
            </BannerImageContainer>
        </Banner>
    );
};

export default GoogleWorkspaceBanner;
